<template>
    <section v-if="carouselData && carouselData.length" class="category-tags catalog-section">
        <div class="container-fluid">
            <h2 v-if="header">{{ header }}</h2>

            <carousel classes="tag-carousel" :items="carouselData" :options="options" :show-navigation="showNavigation">
                <template #slide="{ item }">
                    <a class="tag-item" :class="{'invisible': item.url === ''}" :href="item.url">{{ item.name }}</a>
                </template>
            </carousel>
        </div>
    </section>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import Carousel from "./Carousel";
import windowWidth from "../../mixins/windowWidth";

export default {
    name: "Tag",
    props: {
        type: {
            type: String,
            required: false,
            default: 'popularLinks'
        },
        header: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        Carousel,
    },
    mixins: [
        windowWidth
    ],
    data() {
        return {
            options: {
                slidesPerView: 'auto',
                slidesPerGroup: 3,
            }
        }
    },
    created() {
        if (this.windowWidth < 768) {
            this.options.slidesPerGroup = 1;
        }
    },
    computed: {
        ...mapState('catalog', [
            'popularLinks',
            'filters',
        ]),
        ...mapGetters('catalog', [
            'selectedCategory'
        ]),
        showNavigation() {
            return !this.$q.platform.is.mobile && this.popularLinks.length >= 3;
        },
        carouselData () {
            if (this.type === 'brands') {
                try {
                    return [...this.filters.brand].filter(brand => brand.count >= 3).map(brand => {
                        return {
                            name: brand.name,
                            url: basePath + this.selectedCategory.slug + '/brand_' + brand.slug + '/'
                        };
                    });
                } catch (e) {
                    return [];
                }
            }

            return this.popularLinks;
        }
    },
}
</script>
